import * as React from 'react';
import styled, { withTheme } from 'styled-native-components';
import Svg, { Path } from 'svgs';

import { Button, Touchable, Gradient, Dialog, Heading, Paragraph } from '@cinuru/components';

const Wrapper = styled.View`
	align-items: center;
`;

const Card = styled(Touchable).attrs({
	noCursor: true,
})`
	cursor: auto;
	width: 50rem;
	padding: 11rem 6rem 6rem;
	border-radius: 2rem;
	elevation: 4;
	align-items: center;
	background-color: $background0;
	margin-bottom: 50%;
`;

const ICON_SIZE = 24;

const Background = styled(Gradient).attrs((p) => ({
	colors: p.theme.colors.accentGradient0,
	orientation: 'DIAGDOWN',
}))`
	border-radius: ${ICON_SIZE / 2}rem;
	width: ${ICON_SIZE}rem;
	height: ${ICON_SIZE}rem;
	overflow: hidden;
	margin-bottom: -8rem;
	z-index: 1;
	elevation: 5;
`;

const SizedSvg = withTheme(({ theme, ...props }) => (
	<Svg
		width={theme.rem * ICON_SIZE}
		height={theme.rem * ICON_SIZE}
		viewBox="0 0 120 120"
		{...props}
	/>
));

const ColoredPath = withTheme(({ theme, ...props }) => (
	<Path fill={theme.colors.background0} fillRule="evenodd" {...props} />
));

const CampaignActivationDialog = ({ campaignName, userGroupSize, onConfirm, dismissPortal }) => (
	<Wrapper>
		<Background>
			<SizedSvg>
				<ColoredPath d="M96.893,73.813 L105.907,73.813 L105.907,84.68 L68.887,84.68 L68.887,120.75 L66.387,120.75 L66.387,84.68 L61.787,84.68 L61.787,91.004 L59.287,91.004 L59.287,84.68 L57.139,84.68 L57.139,120.75 L54.639,120.75 L54.639,84.68 L21,84.68 L21,73.814 L30.319,73.814 L30.319,69.087 L23.453,69.087 L23.453,46.861 L30.413,46.861 C31.028,42.29 34.944,38.751 39.68,38.751 L69.84,38.751 L69.84,23 L91.099,23 L91.099,34.206 L72.34,34.206 L72.34,38.751 L87.533,38.751 C92.694,38.751 96.893,42.95 96.893,48.111 L96.893,73.813 Z M72.34,25.5 L72.34,31.707 L88.599,31.707 L88.599,25.5 L72.34,25.5 Z M94.393,48.111 C94.393,44.71 91.902,41.887 88.65,41.35 C90.435,43.056 91.554,45.453 91.554,48.111 L91.554,73.813 L94.393,73.813 L94.393,48.111 Z M71.09,58.158 C70.012,58.158 69.135,59.035 69.135,60.113 C69.135,61.191 70.012,62.068 71.09,62.068 C72.167,62.068 73.044,61.191 73.044,60.113 C73.044,59.035 72.167,58.158 71.09,58.158 Z M69.84,55.859 L69.84,54.564 C67.301,55.136 65.397,57.405 65.397,60.114 C65.397,63.252 67.95,65.806 71.09,65.806 C74.228,65.806 76.782,63.253 76.782,60.114 C76.782,57.405 74.879,55.136 72.34,54.564 L72.34,55.859 C74.185,56.403 75.544,58.093 75.544,60.113 C75.544,62.569 73.546,64.568 71.09,64.568 C68.634,64.568 66.635,62.57 66.635,60.113 C66.635,58.094 67.994,56.403 69.84,55.859 Z M69.84,52.026 L69.84,41.252 L58.555,41.252 C59.418,42.777 59.898,44.533 59.898,46.334 L59.898,73.814 L89.054,73.814 L89.054,48.112 C89.054,44.329 85.977,41.252 82.194,41.252 L72.34,41.252 L72.34,52.026 C76.264,52.631 79.282,56.022 79.282,60.113 C79.282,64.63 75.607,68.305 71.09,68.305 C66.573,68.305 62.897,64.63 62.897,60.113 C62.897,56.022 65.915,52.631 69.84,52.026 Z M55.509,41.252 L55.509,41.251 L50.478,41.251 C52.325,42.962 53.491,45.4 53.491,48.111 L53.491,73.814 L57.399,73.814 L57.399,46.334 C57.399,44.441 56.711,42.62 55.509,41.252 Z M39.68,41.252 C36.324,41.252 33.529,43.674 32.939,46.862 L50.871,46.862 C50.281,43.675 47.486,41.252 44.131,41.252 L39.68,41.252 Z M25.953,49.361 L25.953,66.587 L50.99,66.587 L50.99,64.568 L42.828,64.568 L42.828,62.068 L50.99,62.068 L50.99,59.494 L42.828,59.494 L42.828,56.994 L50.99,56.994 L50.99,54.421 L42.828,54.421 L42.828,51.921 L50.99,51.921 L50.99,49.361 L25.953,49.361 Z M50.99,69.087 L32.819,69.087 L32.819,73.814 L50.99,73.814 L50.99,69.087 Z M103.406,82.18 L103.406,76.313 L96.893,76.313 L96.893,76.314 L31.569,76.314 L30.319,76.314 L23.5,76.314 L23.5,82.18 L103.406,82.18 Z M28.703,64.568 L28.703,51.921 L40.203,51.921 L40.203,64.568 L28.703,64.568 Z M31.203,54.421 L31.203,62.068 L37.703,62.068 L37.703,54.421 L31.203,54.421 Z M59.286,94.504 L61.786,94.504 L61.786,120.75 L59.286,120.75 L59.286,94.504 Z" />
			</SizedSvg>
		</Background>
		<Card>
			<Heading size="xl" align="center" color="$accent0">
				AUF GEHT’S
			</Heading>
			<Paragraph margin="2rem 0rem 3rem" align="center" bold color="$neutral2">
				Soll die {campaignName} Kampagne an {userGroupSize} Nutzer*innen verschickt werden?
			</Paragraph>
			<Button
				label="JETZT AKTIVIEREN"
				gradient="accentGradient0"
				textColor="$background0"
				onPress={async () => {
					if (onConfirm) await onConfirm();
					dismissPortal();
				}}
			/>
			<Button label="ABBRECHEN" textColor="$neutral2" link onPress={dismissPortal} />
		</Card>
	</Wrapper>
);

CampaignActivationDialog.show = (props) =>
	Dialog.render({
		// eslint-disable-next-line react/display-name
		renderContent: ({ dismissPortal }) => (
			<CampaignActivationDialog {...props} dismissPortal={dismissPortal} />
		),
	});

export default CampaignActivationDialog;
